/* ================================ */
/* CUSTOM DROPDOWN JQUERY PLUGIN */
/* ================================ */

(function ($) {
  "use strict";

  // Custom Dropdown Plugin
  $.fn.customDropdown = function (options) {
    const settings = $.extend(
      {
        placeholder: "Select an option",
        multiSelect: false,
        searchable: false,
        clearable: true,
      },
      options,
    );

    return this.each(function () {
      const $wrapper = $(this);
      const $select = $wrapper.find(".cw-filter__select");

      // Skip if already initialized
      if ($wrapper.hasClass("custom-dropdown-active")) return;

      // Mark as initialized
      $wrapper.addClass("custom-dropdown-active");

      // Get dropdown title from select name or data attribute
      const dropdownTitle =
        $wrapper.data("title") || $select.attr("name") || "Select";

      // Build custom dropdown HTML
      const $customDropdown = $(`
        <div class="custom-dropdown">
        <!--   <div class="custom-dropdown__header">
            <h4 class="custom-dropdown__title">${dropdownTitle}</h4>
          </div> -->
          <div class="custom-dropdown__content">
            ${buildOptions($select, settings.multiSelect)}
          </div>
          ${settings.clearable ? '<div class="custom-dropdown__clear"><button class="custom-dropdown__clear-btn">Clear (0)</button></div>' : ""}
        </div>
      `);

      // Create overlay
      const $overlay = $('<div class="custom-dropdown-overlay"></div>');

      // Append to wrapper and body
      $wrapper.append($customDropdown);
      $("body").append($overlay);

      // Create display element for selected value
      const $display = $('<span class="cw-filter__select-display"></span>');
      $wrapper.append($display);
      updateDisplay();

      // Store reference to custom dropdown on wrapper for external access
      $wrapper.data('customDropdown', {
        getValue: getValue,
        getValues: getValues,
        setValue: setValue,
        getText: getText,
        clear: clearSelection
      });

      // Toggle dropdown on wrapper click
      $wrapper.on("click", function (e) {
        if ($(e.target).closest(".custom-dropdown").length === 0) {
          e.preventDefault();
          e.stopPropagation();
          toggleDropdown();
        }
      });

      // Option click handler
      $customDropdown.on("click", ".custom-dropdown__option", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $option = $(this);
        const value = $option.attr("data-value");
        const $radio = $option.find('.custom-dropdown__input');

        // Check if this option has a Shopify filter URL — use AJAX filter
  var filterUrl = $option.attr("data-url");

  // If Shopify filter option (has data-url)
  if (filterUrl) {
      if (typeof window.cwAjaxFilter === "function") {
          window.cwAjaxFilter(filterUrl);
      } else {
          window.location.href = filterUrl;
      }
      return;
  }

  // If this is a collection dropdown
  if ($select.is("[data-collection-select]")) {
      var collectionUrl = value;

      if (typeof window.cwAjaxFilter === "function") {
          window.cwAjaxFilter(collectionUrl);
      } else {
          window.location.href = collectionUrl;
      }

      closeDropdown();
      return;
  }


        if (settings.multiSelect) {
          // Multi-select behavior
          $option.toggleClass("selected");
          $radio.prop('checked', $option.hasClass("selected"));

          const $nativeOption = $select.find('option[value="' + value + '"]');
          $nativeOption.prop("selected", $option.hasClass("selected"));
        } else {
          // Single select behavior
          $customDropdown
            .find(".custom-dropdown__option")
            .removeClass("selected");

          // Uncheck all radio buttons
          $customDropdown.find('.custom-dropdown__input').prop('checked', false);

          // Select current option
          $option.addClass("selected");
          $radio.prop('checked', true);

          // Update native select
          $select.val(value).trigger("change");

          // Close dropdown
          closeDropdown();
        }

        updateDisplay();
        updateClearButton();
      });

      // Clear button handler
      $customDropdown.on("click", ".custom-dropdown__clear-btn", function (e) {
        e.preventDefault();
        e.stopPropagation();

        clearSelection();
      });

      // Close on overlay click
      $overlay.on("click", closeDropdown);

      // Close on escape key
      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && $customDropdown.hasClass("active")) {
          closeDropdown();
        }
      });

      // Public Methods
      function getValue() {
        return $select.val();
      }

      function getValues() {
        if (settings.multiSelect) {
          const values = [];
          $customDropdown.find('.custom-dropdown__input:checked').each(function() {
            values.push($(this).val());
          });
          return values;
        }
        return getValue();
      }

      function setValue(value) {
        $select.val(value).trigger('change');
      }

      function getText() {
        return $display.text();
      }

      function clearSelection() {
        // Clear all selections
        $customDropdown
          .find(".custom-dropdown__option")
          .removeClass("selected");

        // Uncheck all radio/checkbox inputs
        $customDropdown.find('.custom-dropdown__input').prop('checked', false);

        // Reset native select to first option or empty
        $select.prop("selectedIndex", 0).trigger("change");

        updateDisplay();
        updateClearButton();

        // If this is a filter or collection dropdown, navigate to the appropriate URL
        if ($select.is('[data-collection-select]')) {
          // Collection dropdown: go to "All Products" collection to show everything
          var allUrl = $select.attr('data-all-url') || '/collections/all';
          closeDropdown();
          if (typeof window.cwAjaxFilter === 'function') {
            window.cwAjaxFilter(allUrl);
          } else {
            window.location.href = allUrl;
          }
        } else if ($select.is('[data-filter-select]')) {
          // Filter dropdown: go to the current collection URL without filters
          var filterBar = document.getElementById('cwFilterBar');
          var baseUrl = filterBar ? filterBar.getAttribute('data-collection-url') : window.location.pathname;
          closeDropdown();
          if (typeof window.cwAjaxFilter === 'function') {
            window.cwAjaxFilter(baseUrl);
          } else {
            window.location.href = baseUrl;
          }
        }
      }

      // Private Functions
      function toggleDropdown() {
        const isActive = $customDropdown.hasClass("active");

        // Close all other dropdowns
        $(".custom-dropdown").removeClass("active");
        $(".cw-filter__dropdown").removeClass("active");
        $(".custom-dropdown-overlay").removeClass("active");

        if (!isActive) {
          $customDropdown.addClass("active");
          $wrapper.addClass("active");
          $overlay.addClass("active");
        }
      }

      function closeDropdown() {
        $customDropdown.removeClass("active");
        $wrapper.removeClass("active");
        $overlay.removeClass("active");
      }

      function updateDisplay() {
        const selectedOptions = $customDropdown.find(
          ".custom-dropdown__option.selected",
        );

        if (selectedOptions.length === 0) {
          // Show placeholder
          $display.text($select.find("option:first").text());
          $wrapper.removeClass("has-selection");
        } else if (settings.multiSelect) {
          // Show count for multi-select
          const count = selectedOptions.length;
          $display.text(`${count} selected`);
          $wrapper.addClass("has-selection");
        } else {
          // Show selected option text
          $display.text(
            selectedOptions.first().find(".custom-dropdown__label").text(),
          );
          $wrapper.addClass("has-selection");
        }
      }

      function updateClearButton() {
        const selectedCount = $customDropdown.find(
          ".custom-dropdown__option.selected",
        ).length;
        const $clearBtn = $customDropdown.find(".custom-dropdown__clear-btn");

        if ($clearBtn.length > 0) {
          $clearBtn.text(`Clear (${selectedCount})`);
        }
      }

      // Build options from native select
      function buildOptions($select, multiSelect) {
        let html = "";
        const selectedValue = $select.val();
        const selectName = $select.attr('name') || 'custom-dropdown';
        const uniqueId = Math.random().toString(36).substr(2, 9);

        $select.find("option").each(function (index) {
          const $option = $(this);
          const value = $option.val();
          const text = $option.text();
          const dataUrl = $option.attr('data-url') || '';

          // Skip hidden/disabled placeholder options
          if ($option.is(":disabled") || $option.attr("hidden")) return;

          const isSelected = value === selectedValue ? "selected" : "";
          const checkedAttr = value === selectedValue ? "checked" : "";
          const inputType = multiSelect ? "checkbox" : "radio";
          const inputId = `${selectName}-${uniqueId}-${index}`;

          html += `
            <div class="custom-dropdown__option ${isSelected}" data-value="${value}" data-url="${dataUrl}">
              <input
                type="${inputType}"
                name="${selectName}-custom"
                id="${inputId}"
                value="${value}"
                class="custom-dropdown__input"
                ${checkedAttr}
              />
              <label for="${inputId}" class="custom-dropdown__checkbox">
               <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.02841 1.93756C4.69956 1.93756 3.63634 2.2002 2.91824 2.9183C2.20014 3.63641 1.9375 4.69963 1.9375 6.02847V9.09665C1.9375 10.4255 2.20014 11.4887 2.91824 12.2068C3.63634 12.9249 4.69956 13.1876 6.02841 13.1876H9.09659C10.4254 13.1876 11.4887 12.9249 12.2068 12.2068C12.9249 11.4887 13.1875 10.4255 13.1875 9.09665V6.02847C13.1875 4.69963 12.9249 3.63641 12.2068 2.9183C11.4887 2.2002 10.4254 1.93756 9.09659 1.93756H6.02841ZM2.96023 6.02847C2.96023 4.8005 3.20895 4.07394 3.64142 3.64148C4.07388 3.20901 4.80044 2.96029 6.02841 2.96029H9.09659C10.3246 2.96029 11.0511 3.20901 11.4836 3.64148C11.916 4.07394 12.1648 4.8005 12.1648 6.02847V9.09665C12.1648 10.3246 11.916 11.0512 11.4836 11.4836C11.0511 11.9161 10.3246 12.1648 9.09659 12.1648H6.02841C4.80044 12.1648 4.07388 11.9161 3.64142 11.4836C3.20895 11.0512 2.96023 10.3246 2.96023 9.09665V6.02847Z" fill="white"/>
</svg>
              </label>
              <label for="${inputId}" class="custom-dropdown__label">${text}</label>
            </div>
          `;
        });

        return html;
      }

      // Listen to native select changes (for programmatic updates)
      $select.on("change", function () {
        const newValue = $(this).val();

        // Update custom dropdown selection
        $customDropdown
          .find(".custom-dropdown__option")
          .removeClass("selected");

        // Uncheck all inputs
        $customDropdown.find('.custom-dropdown__input').prop('checked', false);

        // Select and check the new option
        const $newOption = $customDropdown.find(`.custom-dropdown__option[data-value="${newValue}"]`);
        $newOption.addClass("selected");
        $newOption.find('.custom-dropdown__input').prop('checked', true);

        updateDisplay();
        updateClearButton();
      });

      // Initial update
      updateClearButton();
    });
  };
$(document).on("click", ".cw-filter-clear", function (e) {
    e.preventDefault();

    var $collectionSelect = $("select[data-collection-select]");

    // If collection dropdown exists
    if ($collectionSelect.length) {
        var allCollectionUrl = "/collections/all";

        if (typeof window.cwAjaxFilter === "function") {
            window.cwAjaxFilter(allCollectionUrl);
        } else {
            window.location.href = allCollectionUrl;
        }

        return;
    }

    // fallback (normal filter clear)
    window.location.href = window.location.pathname;
});

  // Auto-initialize on document ready
  $(document).ready(function () {
    // Initialize ALL filter dropdowns
    $(".cw-filter__dropdown").each(function () {
      $(this).customDropdown({
        multiSelect: false,
        clearable: true,
      });
    });
  });
})(jQuery);